(function () {
  function toggleIwishCounterVisibility() {

    const emptyWishlist = document.querySelector('.iwishPage.header__icon');
    if (emptyWishlist && emptyWishlist.querySelector('.iwish-counter').textContent === '0') {
      emptyWishlist.classList.add('empty-wishlist');
    } else {
      emptyWishlist.classList.remove('empty-wishlist');
    }

    document.querySelectorAll('.iwish-counter').forEach((el) => {
      const n = parseInt((el.textContent || '').trim(), 10);
      const count = Number.isFinite(n) ? n : 0;
      el.toggleAttribute('hidden', count <= 0);
    });
  }

  function patchIwish(attempts) {
    if (window.iWish && typeof window.iWish.setCounter === 'function') {
      const originalSetCounter = window.iWish.setCounter.bind(window.iWish);

      window.iWish.setCounter = function () {
        originalSetCounter();
        toggleIwishCounterVisibility();
      };

      // copre il primo render (iWish.init() chiama setCounter, ma così sei sicuro)
      toggleIwishCounterVisibility();
      return;
    }

    if (attempts > 0) setTimeout(() => patchIwish(attempts - 1), 200);
  }

  document.addEventListener('DOMContentLoaded', () => {
    toggleIwishCounterVisibility(); // nasconde lo "0" iniziale se presente
    patchIwish(30);                 // aspetta fino a ~6s che iWish sia disponibile
  });
})();